export default "__VITE_ASSET__oheNGXB2__"